import React, { PureComponent } from "react";
import "./sign-up-sect.scss";

class SignUpSect extends PureComponent {
  render() {
    return (
      <div className="sign-up-sect">
        <div className="sign-up-sect__inner">{this.props.children}</div>
      </div>
    );
  }
}

export default SignUpSect;
